import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you do not already have an npm user account, you can create an account in order to share and download Javascript packages on the public registry.`}</p>
    <h2>{`Creating an account on the website`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://www.npmjs.com/signup"
          }}>{`npm signup page`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the user signup form, type in the fields:`}</p>
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`Username:`}</strong>{` The username that will be displayed when you publish packages or interact with other npm users on npmjs.com. Your username must be lower case, and can contain hyphens and numerals.`}</li>
          <li parentName="ul"><strong parentName="li">{`Email address:`}</strong>{` Your public email address will be added to the metadata of your packages and will be visible to anyone who downloads your packages. We will also send email to this account when you update packages, as well as occasional product updates and information.`}</li>
          <li parentName="ul"><strong parentName="li">{`Password`}</strong>{`: Your password must meet `}<a parentName="li" {...{
              "href": "creating-a-strong-password"
            }}>{`our password guidelines`}</a>{`.`}</li>
        </ul>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/signup-form.png" alt="Screenshot of the signup form" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Read the `}<a parentName="p" {...{
            "href": "https://www.npmjs.com/policies/terms"
          }}>{`End User License Agreement`}</a>{` and `}<a parentName="p" {...{
            "href": "https://www.npmjs.com/policies/privacy"
          }}>{`Privacy Policy`}</a>{`, and indicate that you agree to them.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/privacy-policy.png" alt="Screenshot of the privacy policy" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Create An Account`}</strong>{`.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/create-account-button.png" alt="Screenshot of the create account button" mdxType="Screenshot" />
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` After signing up for an npm account, you will receive an account verification email. You must verify your email address in order to publish packages to the registry.`}</p>
    </Note>
    <h2>{`Testing your new account with npm login`}</h2>
    <p>{`Use the `}<a href="https://docs.npmjs.com/cli/adduser"><inlineCode parentName="p">{`npm login`}</inlineCode></a>{` command to test logging in to your new account.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` If you misspell your existing account username when you log in with the `}<inlineCode parentName="p">{`npm login`}</inlineCode>{` command, you will create a new account with the misspelled name. For help with accidentally-created accounts, `}<a href="https://www.npmjs.com/support">{`contact npm Support`}</a>{`.`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, type the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm login
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted, enter your username, password, and email address.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you have `}<a parentName="p" {...{
            "href": "about-two-factor-authentication"
          }}>{`two-factor authentication`}</a>{` enabled, when prompted, enter a one-time password.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To test that you have successfully logged in, type:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm whoami
`}</code></pre>
        <p parentName="li">{`Your npm username should be displayed.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      